import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { EmailConfirmationComponent } from './email-confirmation/email-confirmation.component';
import { SuccessComponent } from './success/success.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [OnboardingComponent, EmailConfirmationComponent, SuccessComponent],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class OnboardingModule { }
